import { render, staticRenderFns } from "./RatingReply.vue?vue&type=template&id=0714f220&scoped=true&"
import script from "./RatingReply.vue?vue&type=script&lang=js&"
export * from "./RatingReply.vue?vue&type=script&lang=js&"
import style0 from "./RatingReply.vue?vue&type=style&index=0&id=0714f220&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0714f220",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VDivider,VIcon,VListItem,VListItemAvatar,VListItemContent,VListItemTitle,VProgressCircular,VSheet})
